import { getBasePath } from "@/config/basePath";

export const PUBLIC_ROUTES = [
  "/auth/login",
  "/auth/register",
  "/auth/signup",
  "/auth/forgot-password",
  "/auth/reset-password",
] as const;

export function getPublicRoutes(): string[] {
  const basePath = getBasePath();
  const routes: string[] = [...PUBLIC_ROUTES];

  if (basePath) {
    PUBLIC_ROUTES.forEach((route) => {
      routes.push(`${basePath}${route}`);
    });
  }

  return routes;
}

export function getLoginUrl(): string {
  const basePath = getBasePath();
  return basePath ? `${basePath}/auth/login` : "/auth/login";
}

export function getDashboardUrl(): string {
  const basePath = getBasePath();
  return basePath ? `${basePath}/` : "/";
}

export const redirectHelpers = {
  toDashboard: () => {
    if (typeof window !== "undefined") {
      window.location.href = getDashboardUrl();
    }
  },
  toLogin: () => {
    if (typeof window !== "undefined") {
      window.location.href = getLoginUrl();
    }
  },
};

export function isPublicRoute(pathname: string): boolean {
  const publicRoutes = getPublicRoutes();
  return publicRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}

export function isProtectedRoute(pathname: string): boolean {
  return !isPublicRoute(pathname);
}
